/* eslint-disable no-restricted-syntax, arrow-body-style */

import { mapActions } from 'vuex';
import { toCents } from '@/utils/helpers';

export default {
  props: {
    slim: {
      type: Boolean,
      default: false,
    },
    contract: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      required: true,
      default: [],
    },
    operationValue: {
      type: String,
      default: 'yes',
      validator: value => ['no', 'yes'].indexOf(value) >= 0,
    },
    operationType: {
      type: String,
      default: 'buy',
      validator: value => ['buy', 'sell'].indexOf(value) >= 0,
    },
  },
  data() {
    return {
      deleteAllMode: false,
      deleteOfferId: null,
    };
  },
  computed: {
    classModifiers() {
      return {
        'order-book-offers': true,
        'order-book-offers--delete-all': this.deleteAllMode,
      };
    },
    tableModifiers() {
      return {
        'order-book__table': true,
        'order-book__table--slim': this.slim,
      };
    },
    offers() {
      const items = this.items.map((o) => {
        return {
          ...o,
          pricePerShare: toCents(o.pricePerShare),
        };
      });
      items.sort((prev, next) => {
        if (prev.pricePerShare === next.pricePerShare) {
          return 0;
        }
        let result = 1;
        if (prev.pricePerShare < next.pricePerShare) result = -1;

        return this.operationType === 'buy' ? -result : result;
      });
      return items;
    },
    showProcessedNotice() {
      for (const item of this.offers) {
        if (!item.isProcessed) return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions('market', ['getMarket']),
    ...mapActions('trade', [
      'cancelOffer', 'cancelAllOffers', 'getContractOffers', 'getOrderBook',
      'setTradeOptions',
    ]),
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('notifications', ['setSuccessSideNotification']),
    deleteClicked(offerId) {
      this.cancelClicked();
      this.deleteOfferId = offerId;
    },
    confirmDeleteClicked(offerId) {
      this.cancelOffer(offerId).then(
        () => {
          this.setCurrentPopup();
          this.setTradeOptions(null);
          this.setSuccessSideNotification('Your offer has been removed.');
          this.getContractOffers(this.contract.contractId);
        },
      ).catch(() => this.cancelClicked());
    },
    confirmDeleteAllClicked() {
      const payload = {
        contractId: this.contract.contractId,
        offerType: this.operationType,
      };
      this.cancelAllOffers(payload).then(
        () => {
          this.setCurrentPopup();
          this.setTradeOptions(null);
          this.setSuccessSideNotification('Your offers have been removed.');
          this.getContractOffers(this.contract.contractId);
          this.cancelClicked();
        },
      ).catch(() => this.cancelClicked());
    },
    deleteAllClicked() {
      this.cancelClicked();
      this.deleteAllMode = true;
    },
    cancelClicked() {
      this.deleteAllMode = false;
      this.deleteOfferId = null;
    },
  },
  created() {
    this.cancelClicked();
  },
};



// WEBPACK FOOTER //
// ./src/components/order-book/order-book-offers/order-book-offers.js